// extracted by mini-css-extract-plugin
export default {"container":"AuthConsumeStatus-module__container_xHfGO","loading":"AuthConsumeStatus-module__loading_escmY"};